// extracted by mini-css-extract-plugin
export default {"containerUploadImages":"styles_containerUploadImages__GCp05","descriptionButtons":"styles_descriptionButtons__eQiC5","redText":"styles_redText__QIt9r"};